// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b483f30","732":"29e3dfb0"}[chunkId] + ".chunk.js";
};